/* src/app/webhook-creator/webhook-creator/webhook-new-item/webhook-new-item.component.scss */
.multiple-context {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
}
.label-switch {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
.content-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: auto;
  padding: 5px;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
/*# sourceMappingURL=webhook-new-item.component.css.map */
